export const validationMessages = {
  valueIsEmpty: "Значение не задано",
  valueIsNotEqualToTargetValue: "Значение не равно целевому",
  valueIsLessThanTargetValue: "Значение меньше целевого",
  valueIsMoreThanTargetValue: "Значение больше целевого",
  totalWorkHoursIsInvalid: "Сумма часов контрольных и практических работ превышает значение \"Всего часов\"",
} as const;